import ApiWebCallEvo, {
    API_URL_USER_PART
} from "./calls/evo-api-call";
import Cookies from "js-cookie";

export default class UserDetailDataProvider  {

    constructor() {}

    /**
     *
     * @param userId
     * @param authToken
     * @param params
     * @param headers
     */
    public async getData(userId : number, authToken: string, params = {}, headers: { [key: string | number]: string | number} = {}) {

        /** @ts-ignore */
        params["id_user"] = userId;
        headers["Auth-token"] = authToken;

        let apiCall = new ApiWebCallEvo(
            API_URL_USER_PART + '/' + userId + '/detail',
            params,
            headers
        );

        let res = await apiCall.makeCall();

        return res;
    }
}